import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import { usePopup } from "components/common/wrappers/withPopup";
import axios from "axios";
import SignupConfirmationModal from "common/SignupConfirmationModal";
// import { Timer } from "@tomocredit/common-fe/components";
import { isValidEmail } from "@tomocredit/common-fe/utils";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts";
import { BreakpointContext } from "components/common";
import Email from "common/EmailTomoScore";
import AutoplayCarousel from "common/AutoplayCarousel";
import howItWorksNetflix from "images/boost/how_it_work-netflix.webp";
import howItWorksSpotify from "images/boost/how_it_work-spotify.webp";
import howItWorksATT from "images/boost/how_it_work-att.webp";
import howItWorksMore from "images/more-2.svg";
import TestimonialCard1 from "images/boost/boost_testimonial_card-1.webp";
import TestimonialCard2 from "images/boost/boost_testimonial_card-2.webp";
import TestimonialCard3 from "images/boost/boost_testimonial_card-3.webp";
import TestimonialCard4 from "images/boost/boost_testimonial_card-4.webp";
import SocialProofABC from "images/social_proof_images/ABC.webp";
import SocialProofBI from "images/social_proof_images/Business Insider.webp";
import SocialProofCBS from "images/social_proof_images/CBS.webp";
import SocialProofCNBC from "images/social_proof_images/CNBC.webp";
import SocialProofCNET from "images/social_proof_images/CNET.webp";
import SocialProofFastCompany from "images/social_proof_images/Fast Company.webp";
import SocialProofForbes from "images/social_proof_images/Forbes.webp";
import SocialProofLAT from "images/social_proof_images/LAT.webp";
import SocialProofMastercard from "images/social_proof_images/Mastercard.webp";
import SocialProofMotleyFool from "images/social_proof_images/MotleyFool.webp";
import SocialProofNerdWallet from "images/social_proof_images/Nerdwallet.webp";
import SocialProofNYT from "images/social_proof_images/NYT.webp";
import SocialProofUSAToday from "images/social_proof_images/USA Today.webp";
import SocialProofWSJ from "images/social_proof_images/WSJ.webp";
import SocialProofYahoo from "images/social_proof_images/Yahoo.webp";
import Guard from "images/guard.svg";
import { BoostBannerImage, CheckMark } from "@tomocredit/common-fe/components";
import "react-circular-progressbar/dist/styles.css";

const howItWorksImageNameList = [
  { img: howItWorksNetflix, text: "+50" },
  { img: howItWorksSpotify, text: "+50" },
  { img: howItWorksATT, text: "+50" },
  { img: howItWorksMore, text: "more!" },
];

// list of images to be displayed at the AutoplayCarousel
// if adding/removing items, should update totalWidthPreload
const socialProofImages = [
  { img: SocialProofABC, alt: "ABC" },
  { img: SocialProofBI, alt: "Business Insider" },
  { img: SocialProofCBS, alt: "CBS" },
  { img: SocialProofCNBC, alt: "CNBC" },
  { img: SocialProofCNET, alt: "CNET" },
  { img: SocialProofFastCompany, alt: "Fast Company" },
  { img: SocialProofForbes, alt: "Forbes" },
  { img: SocialProofLAT, alt: "LA Times" },
  { img: SocialProofMastercard, alt: "Mastercard" },
  { img: SocialProofMotleyFool, alt: "MotleyFool" },
  { img: SocialProofNerdWallet, alt: "NerdWallet" },
  { img: SocialProofNYT, alt: "New York Times" },
  { img: SocialProofUSAToday, alt: "USA Today" },
  { img: SocialProofWSJ, alt: "Wall Street Journal" },
  { img: SocialProofYahoo, alt: "Yahoo" },
];

export const BoostLanding = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [modalEmail, setModalEmail] = useState("");
  const [modalState, setModalState] = useState("");
  // const { promoInfo } = useContext(PromoContext);
  const history = useHistory();
  const { hideExitPopup } = usePopup();

  const queryParameters = new URLSearchParams(window.location.search);
  const referralCode = queryParameters.get("referralCode") || "";
  const referralQueryParam = referralCode
    ? `&referralCode=${encodeURIComponent(referralCode)}`
    : "";

  const closeModal = () => {
    setModalState("");
    setModalEmail("");
  };

  const handleSubmit = async (email) => {
    if (loading) {
      return;
    }
    setError(null);
    if (!email) {
      setError("Email address is required");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setLoading(true);

    let signUpBoostRes;
    try {
      const payload = { email, source: LEAD_SOURCES.BOOST_LANDING };
      signUpBoostRes = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/boost/signup`,
        payload,
      );
    } catch (err) {
      setError("Could not communicate with server. Please try again later");
      return;
    } finally {
      setLoading(false);
    }

    const { loginExist, boostEnrolled } = signUpBoostRes?.data ?? {};

    if (loginExist && boostEnrolled) {
      hideExitPopup();
      window.location.assign(
        `${
          process.env.REACT_APP_DOMAIN
        }/dashboard/login?redirect_uri=/boost&email=${encodeURIComponent(
          email,
        )}&existingAccount=true&fromBoost=true`,
      );
      return;
    }
    if (!loginExist && boostEnrolled) {
      setModalState("boostEnrolledWithNoLogin");
      return;
    }
    if (!boostEnrolled) {
      const redirectToStripe = () => {
        // redirect to stripe
        const newUrl = `/boost-pricing?email=${encodeURIComponent(email)}${referralQueryParam}`;
        history.push(newUrl);
      };

      window.fbq?.("track", "Lead");
      window.dataLayer?.push({
        event: "Lead",
        email,
      });
      if (window?.gtag) {
        window?.gtag("event", "boost_new_signup", {
          email,
          event_callback: redirectToStripe,
        });
      } else {
        redirectToStripe();
      }

      return;
    }

    // user not exist
    setError("Could not communicate with server. Please try again later");
  };

  return (
    <div
      className="flex flex-col md:pt-0 justify-center text-white leading-normal"
      style={{ paddingBottom: "30px", letterSpacing: 0.1 }}
    >
      {/* BANNER SECTION */}
      <div
        className="flex w-full justify-evenly items-center xl:flex-row lg:flex-row md:flex-row flex-col-reverse px-6 md:px-10 mx-auto"
        style={{ maxWidth: 1300 }}
      >
        <div className="md:w-1/2">
          <div className="pt-10 hidden md:block">
            <h1 className="mx-2 text-center md:text-left text-5xl xl:text-6xl xl:banner-title banner-title-sm font-semibold pw-7/12 md:w-full tracking-tight leading-none sm:-mt-10 md:mt-0">
              <span>Build Credit Fast</span>
              <span className="text-boost-primary-500">.</span>
            </h1>
          </div>
          <div className="flex flex-col items-start text-left self-center mt-5 lg:mt-8 w-full whitespace-nowrap">
            <div className="flex flex-col md:flex-col w-full justify-start">
              <div className={`${belowMd ? "text-lg" : "text-xl"}`}>
                <CheckMark className="my-4">
                  <span className="">
                    No Credit Checks. <span className="font-bold">EVER.</span>
                  </span>
                </CheckMark>
                <CheckMark className="my-4">
                  <span className="">
                    Boost Credit Score <span className="font-bold">FAST.</span>
                  </span>
                </CheckMark>
                <CheckMark className="my-4">
                  <span className="relative">
                    <span>Raise Score </span><span className="font-bold">100+</span>
                    <span> points.</span>
                  </span>
                </CheckMark>
              </div>

              <div className="self-center md:self-start">
                {/* {promoInfo.showCountDown && (
                  <div className="mt-10 flex flex-wrap place-content-center gap-2 mb-5 text-black">
                    <div className="my-auto font-medium text-lg text-white">
                      {promoInfo.text}
                    </div>
                    <Timer deadline={promoInfo.deadline} />
                  </div>
                )} */}
                <div
                  className="mt-4 flex flex-col lg:flex-row gap-x-4 gap-y-10 box-border"
                  style={{ maxWidth: 507 }}
                >
                  <Email
                    buttonText="Boost my score"
                    handleSubmit={handleSubmit}
                    componentClassName="flex-col md:flex-row space-y-2 md:space-y-0"
                    inputClassName="w-full rounded-md md:rounded-r-none border border-neutral-500 md:border-r-0"
                    buttonClassName="w-full md:w-auto rounded-md md:rounded-l-none border border-boost-primary-500 font-semibold"
                  />
                </div>
                {error && (
                  <p className="text-sm bg-black text-error-200 text-left ml-2 mt-2">
                    {error}
                  </p>
                )}
                <div className="mt-8 flex items-center text-left text-boost-price-green whitespace-pre-wrap w-full">
                  <img src={Guard} alt="" className="inline mr-2 h-4" />
                  <span>
                    Trusted by <span className="font-bold">3.5 million+</span>{" "}
                    people building credit with TomoBoost
                  </span>
                </div>
              </div>

              {modalState && (
                <SignupConfirmationModal
                  email={modalEmail}
                  closeModal={closeModal}
                  modalState={modalState}
                />
              )}
            </div>
          </div>
        </div>
        <div className="mx-auto text-center md:block px-10 relative">
          <div
            className="md:hidden absolute z-50 self-center"
            style={{
              top: "50%",
              left: "50%",
              transform: "translateY(-50%) translateX(-50%)",
            }}
          >
            <h1
              className="mx-2 text-center md:text-left font-bold whitespace-nowrap"
              style={{ fontSize: 40 }}
            >
              <span>Build Credit Fast</span>
              <span className="text-boost-primary-500">.</span>
            </h1>
          </div>
          <div className="opacity-50 md:opacity-100 z-0 mx-6 md:mx-0">
            <BoostBannerImage belowMd={belowMd} />
          </div>
        </div>
      </div>
      {/* TESTIMONIAL CARDS SECTION */}
      <div
        className="mt-10 md:mt-24 flex flex-col justify-center items-center mx-auto"
        style={{ maxWidth: 1300 }}
      >
        <div className="font-bold text-2xl">Hear what others have to say</div>
        <div className="flex overflow-x-scroll hide-x-scrollbar shrink-0 w-full">
          <div className="mx-6 md:mx-10 mt-5 pb-10 flex self-start overflow-visible">
            {
              [TestimonialCard1, TestimonialCard2, TestimonialCard3, TestimonialCard4]
                .map((imageSrc, idx) => (
                  <img
                    alt=""
                    src={imageSrc}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`testimonial-${idx}`}
                    style={{ width: 295, height: "auto" }}
                    className="pr-6 box-content transform hover:scale-110 transition-transform"
                  />
                ))
            }
          </div>
        </div>
      </div>
      {/* SOCIAL PROOF CAROUSEL */}
      <div className="py-8 bg-white">
        <AutoplayCarousel
          titleText="As mentioned in"
          duplicationFactor={3}
          totalWidthPreload={7752} // will need to change this if adding/removing image
          items={socialProofImages.map((item) => {
            return (
              <div className="" style={{ height: 30 }}>
                <img src={item.img} alt={item.alt} className="" />
              </div>
            );
          })}
        />
      </div>
      {/* HOW IT WORK EXAMPLES */}
      <div
        className="mt-10 md:mt-24 px-6 md:px-10 mx-auto"
        style={{ maxWidth: 1300 }}
      >
        <div
          className="flex flex-col md:flex-row space-y-10 md:space-y-0 md:space-x-20"
          id="howItWorks"
        >
          <div className="bg-neutral-700 p-10 flex-1 flex flex-col rounded-lg shrink-0">
            <div className="text-4xl font-bold">
              How It Works<span className="text-boost-primary-500">.</span>
            </div>
            <div className="mt-6">Boost your credit with bills.</div>
            <div className="mt-6 h-10 flex">
              <Link
                to={`/boost-pricing${
                  queryParameters.size ? `?${queryParameters.toString()}` : ""
                }`}
                className="bg-boost-primary-500 px-4 py-2 rounded-md"
              >
                <span className="font-medium text-md">View Pricing</span>
              </Link>
            </div>
          </div>
          <div className="flex-1 space-y-5 mr-5">
            <div className="flex">
              <span className="mr-5 shrink-0" style={{ height: 44, width: 44 }}>
                <CircularProgressbarWithChildren
                  value={33}
                  background="true"
                  strokeWidth="5"
                  styles={{
                    ...buildStyles({
                      backgroundColor: "#4B4B4B",
                      strokeLinecap: "butt",
                      pathColor: "#8E6DF7",
                      trailColor: "black",
                    }),
                  }}
                >
                  <span className="text-xl font-bold text-white">1</span>
                </CircularProgressbarWithChildren>
              </span>
              <span>
                Connect your bill payments with our TomoAI bill finder.
              </span>
            </div>
            <div className="flex">
              <span className="mr-5 shrink-0" style={{ height: 44, width: 44 }}>
                <CircularProgressbarWithChildren
                  value={67}
                  background="true"
                  strokeWidth="5"
                  styles={{
                    ...buildStyles({
                      backgroundColor: "#4B4B4B",
                      strokeLinecap: "butt",
                      pathColor: "#8E6DF7",
                      trailColor: "black",
                    }),
                  }}
                >
                  <span className="text-xl font-bold text-white">2</span>
                </CircularProgressbarWithChildren>
              </span>
              <span>
                Next, we will report on-time payments to the major credit
                bureaus. TomoBoost targets the{" "}
                <a
                  href="https://tomocredit.com/blog/2021/01/15/what-goes-into-your-credit-score/"
                  target="_black"
                  className="underline"
                >
                  5 major credit-score factors
                </a>
                .
              </span>
            </div>
            <div className="flex">
              <span className="mr-5 shrink-0" style={{ height: 44, width: 44 }}>
                <CircularProgressbarWithChildren
                  value={100}
                  background="true"
                  strokeWidth="5"
                  styles={{
                    ...buildStyles({
                      backgroundColor: "#4B4B4B",
                      strokeLinecap: "butt",
                      pathColor: "#8E6DF7",
                      trailColor: "black",
                    }),
                  }}
                >
                  <span className="text-xl font-bold text-white">3</span>
                </CircularProgressbarWithChildren>
              </span>
              <span>
                Sit back and relax. Each month we will build your credit
                history, optimize your utilization, and provide you with all the
                credit-building tools you need.
              </span>
            </div>
            <div>
              <span>Have more questions? </span>
              <Link
                to={`/boost-faq${
                  queryParameters.size ? `?${queryParameters.toString()}` : ""
                }`}
                className="underline"
              >
                Check out our FAQ
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-20 md:mt-24 flex flex-col-reverse md:flex-row md:space-x-6 lg:space-x-20">
          <div className="mt-10 md:mt-0 flex-1 flex flex-col rounded-lg">
            <div
              className="flex justify-between md:justify-start"
              style={{ maxWidth: belowMd ? 450 : undefined }}
            >
              {howItWorksImageNameList.map((item, idx) => (
                <div
                  className={`flex flex-col items-center justify-center box-border bg-neutral-700 rounded-lg p-4 md:p-6 ${
                    idx === howItWorksImageNameList.length - 1
                      ? ""
                      : "border-2 border-boost-primary-400 mr-2 lg:mr-6"
                  }`}
                  key={`${item.img}`}
                  style={{ maxWidth: "22%" }}
                >
                  <div
                    className="rounded-full overflow-hidden"
                    style={{ minWidth: 40, maxWidth: 50, height: "auto" }}
                  >
                    <img
                      className="w-full h-auto rounded-md"
                      alt=""
                      src={item.img}
                    />
                  </div>
                  <p className="text-xl mt-4 font-extrabold">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-neutral-700 p-5 md:p-10 flex-1 flex flex-col rounded-lg">
            <div className="font-bold" style={{ fontSize: belowMd ? 28 : 36 }}>
              Bills Boost Your Credit
              <span className="text-boost-primary-500">.</span>
            </div>
            <div className="mt-6">
              With TomoBoost, your bills like rent, utilities, gym membership,
              insurance, streaming services, and more will build your credit
              score so you can afford your dream car and house.
            </div>
            <div className="mt-6 h-10 flex">
              <Link
                to={`/boost-pricing${
                  queryParameters.size ? `?${queryParameters.toString()}` : ""
                }`}
                className="bg-boost-primary-500 px-4 py-2 rounded-md"
              >
                <span className="font-medium text-md">Boost my score</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
